function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 11.5c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5S10 7.6 10 9s1.1 2.5 2.5 2.5zm0-3.5c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 2.5H7c-1.1 0-2 .9-2 2v2H3.5V8H5v3.2H3.5v1.5H5V16H3.5v1.5H5v2c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2v-15c0-1.1-.9-2-2-2zm.5 17c0 .3-.2.5-.5.5H7c-.3 0-.5-.2-.5-.5v-15c0-.3.2-.5.5-.5h11c.3 0 .5.2.5.5v15z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 12.5h-3c-1.4 0-2.5 1.1-2.5 2.5v2.5H10V15c0-.6.4-1 1-1h3c.6 0 1 .4 1 1v2.5h1.5V15c0-1.4-1.1-2.5-2.5-2.5z",
  fill: "currentColor"
});

function SvgSurveysIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgSurveysIcon;